module.exports = __webpack_public_path__ + "copy.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/copy.svg?color1=%23333333&color2=
// module id = 2193
// module chunks = 67